<template>
  <div>Edit Robots</div>
</template>

<script>
export default {};
</script>